
(function () {
  'use strict';
  angular.module('vcfinance.privcat')
    .component('privcatentryeditor', {
      restrict: 'E',
      bindings: {
        privcatentry: '<?',
        privcatentryid: '<?'
      },
      template: `
        <privcatentryform privcatentry="vm.privcatentry" parentsave="vm.childsave(privcatentry)" oncancel="vm.oncancel()"></privcatentryform>
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Privatleistung erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Editieren einer Privatleistung wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Privatleistung konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Privcat', 'Rlog', '$timeout',
        function ($log, Privcat, Rlog, $timeout) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;
          
/*          vm.$onInit = function () {
            if ((angular.isUndefined(vm.privcatentry) || !vm.privcatentry.hasOwnProperty('_id'))
              && angular.isDefined(vm.privcatentryid)) {
              Privcat.$find(vm.privcatentryid).$then(function (privcatentry) {
                vm.privcatentry = privcatentry;
              }, function (err) {
                $log.error('privcatentry not found, id: ', vm.privcatentryid);
                Rlog.error('privcatentry', 'privcateditor', 'privcatentry not found', {_id: vm.privcatentryid});
              });
            }
          };*/


           vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.privcatentryid) && angular.isDefined(changes.privcatentryid.currentValue) && changes.privcatentryid.currentValue.length > 0) {
              vm.privcatentryid = changes.privcatentryid.currentValue;
              Privcat.$find(vm.privcatentryid).$then(function (privcatentry) {
                vm.privcatentry = privcatentry;
              }, function (err) {
                $log.error('privcatentry not found, id: ', vm.privcatentryid);
                Rlog.error('privcatentry', 'privcateditor', 'privcatentry not found', {_id: vm.privcatentryid});
              });
            }
          };




          
          function childsave(privcatentry) {
            // vm.privcatentry = angular.copy(privcatentry);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in privcatentry) {
              if (privcatentry.hasOwnProperty(key)) {
                vm.privcatentry[key] = privcatentry[key];
              }
            }
            vm.save();
          }
          
          function save() {
            delete vm.canceled;
            delete vm.saved;
            if (vm.privcatentry.$hasPendingActions()) {
              vm.privcatentry.$cancel();
              vm.privcatentry.$save().$then(function () {
                vm.saved = true;
                $timeout(function (){
                  $log.debug('******************** timeout');
                  delete vm.saved;
                }, 3000);
              }, function (err) {
                vm.saved = false;
                $log.error('saving of privcatentry failed: ', err);
                Rlog.error('vcutils.privcatentry', 'privcatentryeditor', 'Saving of privcatentry failed: ', {error: err, privcatentryid: vm.privcatentry._id});
              });
            }
            else {
              vm.privcatentry.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $timeout(function (){
                  delete vm.saved;
                },3000);
                $log.error('saving of privcatentry failed: ', err);
                Rlog.error('vcutils.privcatentry', 'privcatentryeditor', 'Saving of privcatentry failed: ', {error: err, privcatentryid: vm.privcatentry._id});
              });
            }
          }
          
          function oncancel() {
            delete vm.canceled;
            delete vm.saved;
            vm.canceled = true;
            $timeout(function (){
              delete vm.canceled;
            },3000);
          }
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());